<script>
import Tooltip from '@maison/components/common/Tooltip';
import MixedGridFiltersItemList from '@phoenix/mixins/components/mixedGrid/MixedGridFiltersItemList';

export default {
  components: {
    Tooltip,
  },

  mixins: [MixedGridFiltersItemList],

  emits: ['onItemSelected'],

  methods: {
    getInputId(item) {
      return `filtersub-desktop-${this.filter.id}-${item.value}`;
    },

    getCheckboxClasses(item) {
      return { checkbox: true, 'checkbox--disabled': this.itemIsGreyedOut(item) };
    },
  },
};
</script>

<template>
  <ul class="filters-list" data-cy="mixed-grid-filter-list" :data-cy-filter-id="filter.id">
    <li v-for="item in filter.items" :key="item.value">
      <div :class="getCheckboxClasses(item)">
        <input
          :id="getInputId(item)"
          :data-cy="getInputId(item)"
          :data-property="filter.id"
          :data-value="item.value"
          :disabled="itemIsDisabled(item)"
          :checked="itemIsActive(item)"
          type="checkbox"
          :name="getInputId(item)"
          :value="item.value"
          class="checkbox__input"
          @change="$emit('onItemSelected', filter.id, item.value)"
        />

        <label :for="getInputId(item)" :data-cy-filter-value="item.label" class="checkbox__label">
          {{ item.label }}
        </label>

        <tooltip>
          <template #content>
            <div class="rich-text text-xs">
              <div class="mb-xs">
                <strong class="uppercase">{{ $t('Filter.tooltip.watchSizeCategory.roundCase.title') }}</strong>
                <div>{{ $t(`Filter.tooltip.watchSizeCategory.roundCase.${item.valueName}.text`) }}</div>
              </div>
              <div>
                <strong class="uppercase">{{ $t('Filter.tooltip.watchSizeCategory.rectangularCase.title') }}</strong>
                <div>{{ $t(`Filter.tooltip.watchSizeCategory.rectangularCase.${item.valueName}.text`) }}</div>
              </div>
            </div>
          </template>
        </tooltip>
      </div>
    </li>
  </ul>
</template>
